// NEW: UI_REVAMP
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export const GlassAccordionButton = ({ isPath, name, onClick }) => {
	return (
		<Box
			position='relative'
			display='flex'
			alignItems='center'
			justifyContent='start'
			mx={4}
			p={2}
			borderRadius='8px'
			cursor='pointer'
			userSelect='none'
			transition='none'
			transform='none'
			bg={
				isPath
					? `linear-gradient(
                            180deg,
                             rgba(135, 116, 254, 0.2) 0%,
                             rgba(135, 116, 254, 0.15) 40%,
                             rgba(135, 116, 254, 0.1) 100%
                         )`
					: 'transparent'
			}
			boxShadow={
				isPath
					? '1px 1px 3px 1px rgba(91, 6, 145, 0.1), 1px 1px 3px 1px rgba(91, 6, 145, 0.1)'
					: 'none'
			}
			sx={
				isPath
					? {
							filter: `
							  drop-shadow(0px 4px 8px rgba(60, 50, 120, 0.28))
                              drop-shadow(0px 1.5px 3px rgba(60, 50, 120, 0.18))
						`,
						}
					: {}
			}
			onClick={onClick}
		>
			<Text
				ml={9}
				fontSize='20px'
				fontWeight='500'
				letterSpacing='0.5px'
				color={isPath ? 'rgba(57, 49, 107, 1)' : '#000000'}
				whiteSpace='nowrap'
			>
				{name}
			</Text>
			{isPath && (
				<Box
					position='absolute'
					inset={0}
					borderRadius='8px'
					padding='1px'
					zIndex={2}
					pointerEvents='none'
					sx={{
						background: `linear-gradient(
                                                    to bottom right,
                                                    rgba(255,255,255,0.7) 0%,
                                                    rgba(255,255,255,0.4) 45%,
                                               rgba(255,255,255,0.0)  48%,
                                              
                                                    rgba(255,255,255,0.45) 70%,
                                                    rgba(255,255,255,0.45)  100%
                                                    
                                                )`,
						WebkitMask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
						WebkitMaskComposite: 'destination-out',
						mask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
						maskComposite: 'exclude',
					}}
				/>
			)}
		</Box>
	);
};

GlassAccordionButton.propTypes = {
	isPath: PropTypes.bool,
	name: PropTypes.string,
	onClick: PropTypes.func,
};
